export default __webpack_public_path__ + "static/media/art.e1aed274.svg";